/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const HubAlphaSchedulerTaskStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
    FAILED: "FAILED",
    DONE: "DONE",
};
export const HubAnnotationOrigin = {
    EXTERNAL: "EXTERNAL",
    MANUAL: "MANUAL",
    MODEL: "MODEL",
};
export const HubAnnotationSourceKind = {
    USER: "USER",
    JOB: "JOB",
    DEPLOYMENT: "DEPLOYMENT",
    UNKNOWN: "UNKNOWN",
    CUSTOM: "CUSTOM",
};
export const HubAnnotationStatus = {
    COMPLETE: "COMPLETE",
    PARTIAL: "PARTIAL",
    NONE: "NONE",
};
export const HubArrayDataType = {
    Bool: "Bool",
    I8: "I8",
    I16: "I16",
    I32: "I32",
    I64: "I64",
    U8: "U8",
    U16: "U16",
    U32: "U32",
    U64: "U64",
    F16: "F16",
    F32: "F32",
    F64: "F64",
};
export const HubAuthPermissions = {
    PROJECT_CREATION: "PROJECT_CREATION",
    DATA_UPLOAD: "DATA_UPLOAD",
    DATA_LABELING: "DATA_LABELING",
    LABELING_REVIEW: "LABELING_REVIEW",
    MODEL_CREATION: "MODEL_CREATION",
    INFERENCE: "INFERENCE",
    SYSTEM_MANAGEMENT: "SYSTEM_MANAGEMENT",
    EDGE: "EDGE",
};
export const HubBrandingItemId = {
    Logo: "logo",
    Favicon: "favicon",
    PrimaryColor: "primaryColor",
    CookiePolicy: "cookiePolicy",
    PrivacyPolicy: "privacyPolicy",
    TermsAndConditions: "termsAndConditions",
    OnScreenText: "onScreenText",
    DocumentationUrl: "documentationUrl",
};
export const HubBrandingType = {
    Color: "color",
    File: "file",
    Url: "url",
};
export const HubBuildState = {
    CHECKING_COMPATIBILITY: "CHECKING_COMPATIBILITY",
    PENDING: "PENDING",
    READY: "READY",
    FAILED: "FAILED",
    DELETING: "DELETING",
    DELETED: "DELETED",
};
export const HubCameraConfigStatus = {
    VALID: "VALID",
    INVALID: "INVALID",
};
export const HubCameraStatus = {
    IDLE: "IDLE",
    IN_USE: "IN_USE",
};
export const HubCameraType = {
    BASLER: "BASLER",
    ALLIED_VISION: "ALLIED_VISION",
};
export const HubDatapointFieldSourceType = {
    Dataset: "Dataset",
};
export const HubDatapointFieldType = {
    Integer: "Integer",
    Float: "Float",
    Boolean: "Boolean",
    String: "String",
    Class: "Class",
    Datetime: "Datetime",
    UUID: "UUID",
    SampleIDs: "Sample IDs",
};
export const HubDefaultExamplePickingStrategy = {
    LATEST: "LATEST",
    RANDOM: "RANDOM",
    SELECTION: "SELECTION",
    SINGLESOURCE: "SINGLESOURCE",
};
export const HubDeploymentStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
    FAILED: "FAILED",
};
export const HubExamplePickingStrategy = {
    RANDOM: "RANDOM",
    LATEST: "LATEST",
};
export const HubExampleStreamDefinitionType = {
    SAMPLE_DEFINITION: "SAMPLE_DEFINITION",
    EXAMPLE_DEFINITION: "EXAMPLE_DEFINITION",
};
export const HubExampleStreamRunningTaskKind = {
    JOB: "JOB",
    DEPLOYMENT: "DEPLOYMENT",
};
export const HubExampleStreamStatus = {
    IDLE: "IDLE",
    IN_USE: "IN_USE",
    RECORDING: "RECORDING",
    VALIDATING: "VALIDATING",
    INFERENCE: "INFERENCE",
    UNAVAILABLE: "UNAVAILABLE",
    INVALID: "INVALID",
};
export const HubFileEncoding = {
    Plain: "plain",
    Base64: "base64",
};
export const HubImageMode = {
    LU8: "L_U8",
    LF32: "L_F32",
    LF64: "L_F64",
    LAU8: "LA_U8",
    LAF32: "LA_F32",
    LAF64: "LA_F64",
    RGBU8: "RGB_U8",
    RGBF32: "RGB_F32",
    RGBF64: "RGB_F64",
    RGBAU8: "RGBA_U8",
    RGBAF32: "RGBA_F32",
    RGBAF64: "RGBA_F64",
    BGRU8: "BGR_U8",
    BGRF32: "BGR_F32",
    BGRF64: "BGR_F64",
    BGRAU8: "BGRA_U8",
    BGRAF32: "BGRA_F32",
    BGRAF64: "BGRA_F64",
    YCbCrU8: "YCbCr_U8",
    BayerRGU8: "BayerRG_U8",
    BayerRGU10: "BayerRG_U10",
    BayerRGU12: "BayerRG_U12",
    JPEG: "JPEG",
    PNG: "PNG",
    GIF: "GIF",
    BMP: "BMP",
};
export const HubJobKind = {
    ModelTraining: "modelTraining",
    ModelFinetuning: "modelFinetuning",
    AnnotationPrediction: "annotationPrediction",
    AnnotationComparison: "annotationComparison",
    CameraCalibration: "cameraCalibration",
    Recording: "recording",
    Custom: "custom",
};
export const HubJobStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    DONE: "DONE",
    FAILED: "FAILED",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
};
export const HubLogLevel = {
    SYSTEM_STATUS: "SYSTEM_STATUS",
    DEBUG: "DEBUG",
    INFO: "INFO",
    WARNING: "WARNING",
    ERROR: "ERROR",
};
export const HubMetricWidget = {
    Scalar: "Scalar",
    Line: "Line",
    ConfusionMatrix: "Confusion Matrix",
    Bar: "Bar",
    Histogram: "Histogram",
    ROC: "ROC",
    ScoreGraph: "Score Graph",
    Percentage: "Percentage",
};
export const HubPixelDataLayout = {
    HeightWidthChannels: "HeightWidthChannels",
    ChannelsHeightWidth: "ChannelsHeightWidth",
};
export const HubPlatformConnectionStatus = {
    CONNECTED: "CONNECTED",
    HEALTHY: "HEALTHY",
    UNHEALTHY: "UNHEALTHY",
    UNKNOWN: "UNKNOWN",
    DISCONNECTED: "DISCONNECTED",
};
export const HubResourceKind = {
    PARAMETERS: "PARAMETERS",
    EXAMPLES: "EXAMPLES",
    DATASET: "DATASET",
    DATAPOOL: "DATAPOOL",
    MODEL: "MODEL",
    BLOB: "BLOB",
};
export const HubSplitStrategy = {
    RANDOM: "RANDOM",
    STRATIFIED: "STRATIFIED",
};
export const HubStorageCapacityServiceId = {
    Algorithm: "algorithm",
    Data: "data",
    Database: "database",
};
export const HubStorageCapacityStatus = {
    NORMAL: "NORMAL",
    WARNING: "WARNING",
    ALARM: "ALARM",
};
export const HubWorkflowStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    DELETING: "DELETING",
    STOPPED: "STOPPED",
    DONE: "DONE",
    FAILED: "FAILED",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "/hub/api/v1",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
            body = qs.stringify(body);
        }
        if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title RVAI Hub
 * @version 0.1.0
 * @baseUrl /hub/api/v1
 */
export class Api extends HttpClient {
    algorithms = {
        /**
         * @description List algorithms. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name ListAlgorithms
         * @summary List Algorithms
         * @request GET:/algorithms
         * @secure
         */
        listAlgorithms: (query, params = {}) => this.request({
            path: `/algorithms`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List algorithm fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name ListAlgorithmFields
         * @summary List Algorithm Fields
         * @request GET:/algorithms/fields
         * @secure
         */
        listAlgorithmFields: (params = {}) => this.request({
            path: `/algorithms/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new algorithm by uploading thumbnail and algorithm spec. The algorithm image should be prebuilt and pushed to the docker registry. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name CreateNewAlgorithmPrebuilt
         * @summary Create New Algorithm Prebuilt
         * @request POST:/algorithms/prebuilt
         * @secure
         */
        createNewAlgorithmPrebuilt: (data, query, params = {}) => this.request({
            path: `/algorithms/prebuilt`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithms registry details. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmsRegistry
         * @summary Get Algorithms Registry
         * @request GET:/algorithms/registry
         * @secure
         */
        getAlgorithmsRegistry: (params = {}) => this.request({
            path: `/algorithms/registry`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List algorithm types. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name ListAlgorithmTypes
         * @summary List Algorithm Types
         * @request GET:/algorithms/types
         * @secure
         */
        listAlgorithmTypes: (params = {}) => this.request({
            path: `/algorithms/types`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm type. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmType
         * @summary Get Algorithm Type
         * @request GET:/algorithms/types/{algorithm_type}
         * @secure
         */
        getAlgorithmType: (algorithmType, params = {}) => this.request({
            path: `/algorithms/types/${algorithmType}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm type thumbnail. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmTypeThumbnail
         * @summary Get Algorithm Type Thumbnail
         * @request GET:/algorithms/types/{algorithm_type}/thumbnail
         * @secure
         */
        getAlgorithmTypeThumbnail: (algorithmType, params = {}) => this.request({
            path: `/algorithms/types/${algorithmType}/thumbnail`,
            method: "GET",
            secure: true,
            format: "blob",
            ...params,
        }),
        /**
         * @description List daemons for algorithm. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags daemons
         * @name ListAlgorithmDaemons
         * @summary List Algorithm Daemons
         * @request GET:/algorithms/{algorithm_id}/{algorithm_version}/daemons
         * @secure
         */
        listAlgorithmDaemons: (algorithmId, algorithmVersion, params = {}) => this.request({
            path: `/algorithms/${algorithmId}/${algorithmVersion}/daemons`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a daemon. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags daemons
         * @name GetDaemon
         * @summary Get Daemon
         * @request GET:/algorithms/{algorithm_id}/{algorithm_version}/daemons/{definition_id}
         * @secure
         */
        getDaemon: (algorithmId, algorithmVersion, definitionId, params = {}) => this.request({
            path: `/algorithms/${algorithmId}/${algorithmVersion}/daemons/${definitionId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete an algorithm. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name DeleteAlgorithm
         * @summary Delete Algorithm
         * @request DELETE:/algorithms/{id}/{version}
         * @secure
         */
        deleteAlgorithm: (id, version, query, params = {}) => this.request({
            path: `/algorithms/${id}/${version}`,
            method: "DELETE",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithm
         * @summary Get Algorithm
         * @request GET:/algorithms/{id}/{version}
         * @secure
         */
        getAlgorithm: (id, version, params = {}) => this.request({
            path: `/algorithms/${id}/${version}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm definition. If the original flag is set to True, the definition will be returned in the same schema version as it was created by the originating algorithm. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmDefinition
         * @summary Get Algorithm Definition
         * @request GET:/algorithms/{id}/{version}/definition
         * @secure
         */
        getAlgorithmDefinition: (id, version, query, params = {}) => this.request({
            path: `/algorithms/${id}/${version}/definition`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm thumbnail. Supports authorization via ?token. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmThumbnail
         * @summary Get Algorithm Thumbnail
         * @request GET:/algorithms/{id}/{version}/thumbnail
         * @secure
         */
        getAlgorithmThumbnail: (id, version, query, params = {}) => this.request({
            path: `/algorithms/${id}/${version}/thumbnail`,
            method: "GET",
            query: query,
            secure: true,
            format: "blob",
            ...params,
        }),
    };
    alpha = {
        /**
         * @description Retrieve calibration resources for the specified camera. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags alpha, cameras
         * @name ListCameraCalibrationResources
         * @summary List Camera Calibration Resources
         * @request GET:/alpha/cameras/{camera_id}/calibration-resources
         * @secure
         */
        listCameraCalibrationResources: (cameraId, query, params = {}) => this.request({
            path: `/alpha/cameras/${cameraId}/calibration-resources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description If there is a calibration resource for a specified example stream in a project, return the most recent one. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags alpha, example_streams
         * @name ListProjectCalibrationResourcesPerCameraConfig
         * @summary List Project Calibration Resources Per Camera Config
         * @request GET:/alpha/example-streams/{example_stream_id}/calibration-resources/{project_id}/most-recent
         * @secure
         */
        listProjectCalibrationResourcesPerCameraConfig: (projectId, exampleStreamId, query, params = {}) => this.request({
            path: `/alpha/example-streams/${exampleStreamId}/calibration-resources/${projectId}/most-recent`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags alpha
         * @name ListPlatformConnections
         * @summary List Platform Connections
         * @request GET:/alpha/platform-connections/dummy
         * @secure
         */
        listPlatformConnections: (params = {}) => this.request({
            path: `/alpha/platform-connections/dummy`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags alpha
         * @name CreatePlatformConnection
         * @summary Create Platform Connection
         * @request POST:/alpha/platform-connections/dummy
         * @secure
         */
        createPlatformConnection: (data, params = {}) => this.request({
            path: `/alpha/platform-connections/dummy`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags alpha, scheduler
         * @name ListSchedulerTasks
         * @summary List Scheduler Tasks
         * @request GET:/alpha/scheduler/tasks
         * @secure
         */
        listSchedulerTasks: (params = {}) => this.request({
            path: `/alpha/scheduler/tasks`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags alpha, scheduler
         * @name GetSchedulerEvents
         * @summary Get Scheduler Events
         * @request GET:/alpha/scheduler/tasks/sse
         * @secure
         */
        getSchedulerEvents: (params = {}) => this.request({
            path: `/alpha/scheduler/tasks/sse`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags alpha, scheduler
         * @name SaveSchedulerTaskLogs
         * @summary Save Scheduler Task Logs
         * @request POST:/alpha/scheduler/tasks/{task_id}/logs
         * @secure
         */
        saveSchedulerTaskLogs: (taskId, data, params = {}) => this.request({
            path: `/alpha/scheduler/tasks/${taskId}/logs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags alpha, scheduler
         * @name SetSchedulerTaskStatus
         * @summary Set Scheduler Task Status
         * @request PATCH:/alpha/scheduler/tasks/{task_id}/status
         * @secure
         */
        setSchedulerTaskStatus: (taskId, data, params = {}) => this.request({
            path: `/alpha/scheduler/tasks/${taskId}/status`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    branding = {
        /**
         * @description Full reset to defaults for the entire branding configuration. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name ResetToDefaults
         * @summary Reset To Defaults
         * @request DELETE:/branding
         * @secure
         */
        resetToDefaults: (params = {}) => this.request({
            path: `/branding`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name UpdateBranding
         * @summary Update Branding
         * @request PUT:/branding
         * @secure
         */
        updateBranding: (data, params = {}) => this.request({
            path: `/branding`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns a list of all the branding items **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name GetBrandingFields
         * @summary Get Branding Fields
         * @request GET:/branding/fields
         * @secure
         */
        getBrandingFields: (params = {}) => this.request({
            path: `/branding/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Import a branding configuration from a JSON file. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name ImportBrandingConfig
         * @summary Import Branding Config
         * @request POST:/branding/import
         * @secure
         */
        importBrandingConfig: (data, query, params = {}) => this.request({
            path: `/branding/import`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Bulk update the branding configuration. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name BulkUpdateBranding
         * @summary Bulk Update Branding
         * @request PUT:/branding/json
         * @secure
         */
        bulkUpdateBranding: (data, query, params = {}) => this.request({
            path: `/branding/json`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns all the overridden branding items. If an item is None, the default (robovision) branding should be shown.
         *
         * @tags branding
         * @name GetPublicBranding
         * @summary Get Public Branding
         * @request GET:/branding/public
         * @secure
         */
        getPublicBranding: (params = {}) => this.request({
            path: `/branding/public`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    cameras = {
        /**
         * @description List all cameras. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name ListCameras
         * @summary List Cameras
         * @request GET:/cameras
         * @secure
         */
        listCameras: (query, params = {}) => this.request({
            path: `/cameras`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name CreateCamera
         * @summary Create Camera
         * @request POST:/cameras
         * @secure
         */
        createCamera: (data, params = {}) => this.request({
            path: `/cameras`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name DeleteCamera
         * @summary Delete Camera
         * @request DELETE:/cameras/{camera_id}
         * @secure
         */
        deleteCamera: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get camera. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name GetCamera
         * @summary Get Camera
         * @request GET:/cameras/{camera_id}
         * @secure
         */
        getCamera: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name UpdateCamera
         * @summary Update Camera
         * @request PATCH:/cameras/{camera_id}
         * @secure
         */
        updateCamera: (cameraId, data, params = {}) => this.request({
            path: `/cameras/${cameraId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Get camera config. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name GetCameraConfig
         * @summary Get Camera Config
         * @request GET:/cameras/{camera_id}/config
         * @secure
         */
        getCameraConfig: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}/config`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description Update camera activity. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name UpdateCameraStatus
         * @summary Update Camera Status
         * @request PUT:/cameras/{camera_id}/status
         * @secure
         */
        updateCameraStatus: (cameraId, query, params = {}) => this.request({
            path: `/cameras/${cameraId}/status`,
            method: "PUT",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name GetCameraThumbnail
         * @summary Get Camera Thumbnail
         * @request GET:/cameras/{camera_id}/thumbnail
         * @secure
         */
        getCameraThumbnail: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}/thumbnail`,
            method: "GET",
            secure: true,
            format: "blob",
            ...params,
        }),
    };
    classes = {
        /**
         * @description Delete a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name DeleteClasses
         * @summary Delete Classes
         * @request DELETE:/classes
         * @secure
         */
        deleteClasses: (data, params = {}) => this.request({
            path: `/classes`,
            method: "DELETE",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List classess. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags global_classes
         * @name ListClasses
         * @summary List Classes
         * @request GET:/classes
         * @secure
         */
        listClasses: (query, params = {}) => this.request({
            path: `/classes`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create classes. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name CreateClasses
         * @summary Create Classes
         * @request POST:/classes
         * @secure
         */
        createClasses: (data, params = {}) => this.request({
            path: `/classes`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List classes fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags global_classes
         * @name ListClassesFields
         * @summary List Classes Fields
         * @request GET:/classes/fields
         * @secure
         */
        listClassesFields: (params = {}) => this.request({
            path: `/classes/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name DeleteClass
         * @summary Delete Class
         * @request DELETE:/classes/{id}
         * @secure
         */
        deleteClass: (id, params = {}) => this.request({
            path: `/classes/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get class. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags global_classes
         * @name GetClass
         * @summary Get Class
         * @request GET:/classes/{id}
         * @secure
         */
        getClass: (id, params = {}) => this.request({
            path: `/classes/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name UpdateClass
         * @summary Update Class
         * @request PUT:/classes/{id}
         * @secure
         */
        updateClass: (id, data, params = {}) => this.request({
            path: `/classes/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    clusters = {
        /**
         * @description Get compute clusters information.
         *
         * @tags monitor
         * @name GetComputeClusters
         * @summary Get Compute Clusters
         * @request GET:/clusters
         * @secure
         */
        getComputeClusters: (params = {}) => this.request({
            path: `/clusters`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    customAnnotationSources = {
        /**
         * @description List custom annotation sources. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name ListCustomAnnotationSources
         * @summary List Custom Annotation Sources
         * @request GET:/custom-annotation-sources
         * @secure
         */
        listCustomAnnotationSources: (query, params = {}) => this.request({
            path: `/custom-annotation-sources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name CreateCustomAnnotationSource
         * @summary Create Custom Annotation Source
         * @request POST:/custom-annotation-sources
         * @secure
         */
        createCustomAnnotationSource: (data, params = {}) => this.request({
            path: `/custom-annotation-sources`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get custom annotation source by name. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name GetCustomAnnotationSourceByName
         * @summary Get Custom Annotation Source By Name
         * @request GET:/custom-annotation-sources/name/{name}
         * @secure
         */
        getCustomAnnotationSourceByName: (name, params = {}) => this.request({
            path: `/custom-annotation-sources/name/${name}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name DeleteCustomAnnotationSource
         * @summary Delete Custom Annotation Source
         * @request DELETE:/custom-annotation-sources/{id}
         * @secure
         */
        deleteCustomAnnotationSource: (id, params = {}) => this.request({
            path: `/custom-annotation-sources/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name GetCustomAnnotationSource
         * @summary Get Custom Annotation Source
         * @request GET:/custom-annotation-sources/{id}
         * @secure
         */
        getCustomAnnotationSource: (id, params = {}) => this.request({
            path: `/custom-annotation-sources/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name UpdateCustomAnnotationSource
         * @summary Update Custom Annotation Source
         * @request PUT:/custom-annotation-sources/{id}
         * @secure
         */
        updateCustomAnnotationSource: (id, data, params = {}) => this.request({
            path: `/custom-annotation-sources/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List custom annotation source fields. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name ListCustomAnnotationSourceFields
         * @summary List Custom Annotation Source Fields
         * @request GET:/custom-annotation_sources/fields
         * @secure
         */
        listCustomAnnotationSourceFields: (params = {}) => this.request({
            path: `/custom-annotation_sources/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    daemons = {
        /**
         * @description List daemons. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags daemons
         * @name ListDaemons
         * @summary List Daemons
         * @request GET:/daemons
         * @secure
         */
        listDaemons: (params = {}) => this.request({
            path: `/daemons`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    datapools = {
        /**
         * @description List datapools. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListDatapools
         * @summary List Datapools
         * @request GET:/datapools
         * @secure
         */
        listDatapools: (query, params = {}) => this.request({
            path: `/datapools`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a datapool in a project. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CreateDatapool
         * @summary Create Datapool
         * @request POST:/datapools
         * @secure
         */
        createDatapool: (data, params = {}) => this.request({
            path: `/datapools`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List datapool fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListDatapoolFields
         * @summary List Datapool Fields
         * @request GET:/datapools/fields
         * @secure
         */
        listDatapoolFields: (params = {}) => this.request({
            path: `/datapools/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete datapool. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datapools
         * @name DeleteDatapool
         * @summary Delete Datapool
         * @request DELETE:/datapools/{datapool_id}
         * @secure
         */
        deleteDatapool: (datapoolId, params = {}) => this.request({
            path: `/datapools/${datapoolId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get datapool. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetDatapool
         * @summary Get Datapool
         * @request GET:/datapools/{datapool_id}
         * @secure
         */
        getDatapool: (datapoolId, query, params = {}) => this.request({
            path: `/datapools/${datapoolId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get classes of this datapool. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetDatapoolClasses
         * @summary Get Datapool Classes
         * @request GET:/datapools/{datapool_id}/classes
         * @secure
         */
        getDatapoolClasses: (datapoolId, params = {}) => this.request({
            path: `/datapools/${datapoolId}/classes`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update classes of this datapool. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags datapools
         * @name UpdateDatapoolClasses
         * @summary Update Datapool Classes
         * @request PUT:/datapools/{datapool_id}/classes
         * @secure
         */
        updateDatapoolClasses: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/classes`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a dataset. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name CreateDataset
         * @summary Create Dataset
         * @request POST:/datapools/{datapool_id}/datasets
         * @secure
         */
        createDataset: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/datasets`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a dataset split. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name CreateSplit
         * @summary Create Split
         * @request POST:/datapools/{datapool_id}/datasets/splits
         * @secure
         */
        createSplit: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/datasets/splits`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List datapool sources for filtered samples. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListFilteredDatapoolSources
         * @summary List Filtered Datapool Sources
         * @request POST:/datapools/{datapool_id}/filtered-sources
         * @secure
         */
        listFilteredDatapoolSources: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/filtered-sources`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List datapool sources. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListDatapoolSources
         * @summary List Datapool Sources
         * @request GET:/datapools/{datapool_id}/sources
         * @secure
         */
        listDatapoolSources: (datapoolId, query, params = {}) => this.request({
            path: `/datapools/${datapoolId}/sources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
    };
    datasets = {
        /**
         * @description List datasets. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name ListDatasets
         * @summary List Datasets
         * @request GET:/datasets
         * @secure
         */
        listDatasets: (query, params = {}) => this.request({
            path: `/datasets`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List dataset fields. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name ListDatasetFields
         * @summary List Dataset Fields
         * @request GET:/datasets/fields
         * @secure
         */
        listDatasetFields: (params = {}) => this.request({
            path: `/datasets/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete dataset. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name DeleteDataset
         * @summary Delete Dataset
         * @request DELETE:/datasets/{dataset_id}
         * @secure
         */
        deleteDataset: (datasetId, params = {}) => this.request({
            path: `/datasets/${datasetId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get dataset. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name GetDataset
         * @summary Get Dataset
         * @request GET:/datasets/{dataset_id}
         * @secure
         */
        getDataset: (datasetId, query, params = {}) => this.request({
            path: `/datasets/${datasetId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a dataset. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name UpdateDataset
         * @summary Update Dataset
         * @request PATCH:/datasets/{dataset_id}
         * @secure
         */
        updateDataset: (datasetId, data, params = {}) => this.request({
            path: `/datasets/${datasetId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get classes of this dataset. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name GetDatasetClasses
         * @summary Get Dataset Classes
         * @request GET:/datasets/{dataset_id}/classes
         * @secure
         */
        getDatasetClasses: (datasetId, params = {}) => this.request({
            path: `/datasets/${datasetId}/classes`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List dataset sources. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name ListDatasetSources
         * @summary List Dataset Sources
         * @request GET:/datasets/{dataset_id}/sources
         * @secure
         */
        listDatasetSources: (datasetId, params = {}) => this.request({
            path: `/datasets/${datasetId}/sources`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    deployments = {
        /**
         * @description List all deployments. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeployments
         * @summary List Deployments
         * @request GET:/deployments
         * @secure
         */
        listDeployments: (query, params = {}) => this.request({
            path: `/deployments`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a Deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name CreateDeployment
         * @summary Create Deployment
         * @request POST:/deployments
         * @secure
         */
        createDeployment: (data, params = {}) => this.request({
            path: `/deployments`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List deployment fields. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeploymentFields
         * @summary List Deployment Fields
         * @request GET:/deployments/fields
         * @secure
         */
        listDeploymentFields: (params = {}) => this.request({
            path: `/deployments/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a Deployment placeholder. This Deployment placeholder can have dependencies on resources which do not have valid values yet. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name CreateDeploymentPlaceholder
         * @summary Create Deployment Placeholder
         * @request POST:/deployments/placeholder
         * @secure
         */
        createDeploymentPlaceholder: (data, params = {}) => this.request({
            path: `/deployments/placeholder`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Register an external deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name RegisterExternalDeployment
         * @summary Register External Deployment
         * @request POST:/deployments/register
         * @secure
         */
        registerExternalDeployment: (data, params = {}) => this.request({
            path: `/deployments/register`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name DeleteDeployment
         * @summary Delete Deployment
         * @request DELETE:/deployments/{deployment_id}
         * @secure
         */
        deleteDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeployment
         * @summary Get Deployment
         * @request GET:/deployments/{deployment_id}
         * @secure
         */
        getDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name UpdateDeployment
         * @summary Update Deployment
         * @request PATCH:/deployments/{deployment_id}
         * @secure
         */
        updateDeployment: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get deployment api endpoints info. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentApiEndpoints
         * @summary Get Deployment Api Endpoints
         * @request GET:/deployments/{deployment_id}/api-endpoints
         * @secure
         */
        getDeploymentApiEndpoints: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/api-endpoints`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get artifacts of a deployment. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentArtifacts
         * @summary Get Deployment Artifacts
         * @request GET:/deployments/{deployment_id}/artifacts
         * @secure
         */
        getDeploymentArtifacts: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/artifacts`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get deployment dependencies. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentDependencies
         * @summary Get Deployment Dependencies
         * @request GET:/deployments/{deployment_id}/dependencies
         * @secure
         */
        getDeploymentDependencies: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/dependencies`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Log heartbeat for a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name LogHeartbeat
         * @summary Log Heartbeat
         * @request PATCH:/deployments/{deployment_id}/heartbeat
         * @secure
         */
        logHeartbeat: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/heartbeat`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description Get logs of a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentLogs
         * @summary Get Deployment Logs
         * @request GET:/deployments/{deployment_id}/logs
         * @secure
         */
        getDeploymentLogs: (deploymentId, query, params = {}) => this.request({
            path: `/deployments/${deploymentId}/logs`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        /**
         * @description Save logs to deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name SaveDeploymentLogs
         * @summary Save Deployment Logs
         * @request POST:/deployments/{deployment_id}/logs
         * @secure
         */
        saveDeploymentLogs: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/logs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Get latest status messages of a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeploymentMessages
         * @summary List Deployment Messages
         * @request GET:/deployments/{deployment_id}/messages
         * @secure
         */
        listDeploymentMessages: (deploymentId, query, params = {}) => this.request({
            path: `/deployments/${deploymentId}/messages`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Log a status message for a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name LogDeploymentMessage
         * @summary Log Deployment Message
         * @request POST:/deployments/{deployment_id}/messages
         * @secure
         */
        logDeploymentMessage: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/messages`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description List deployment message fields. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeploymentMessageFields
         * @summary List Deployment Message Fields
         * @request GET:/deployments/{deployment_id}/messages/fields
         * @secure
         */
        listDeploymentMessageFields: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/messages/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Start a deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name StartDeployment
         * @summary Start Deployment
         * @request POST:/deployments/{deployment_id}/start
         * @secure
         */
        startDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/start`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update status to deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name UpdateDeploymentStatus
         * @summary Update Deployment Status
         * @request PATCH:/deployments/{deployment_id}/status
         * @secure
         */
        updateDeploymentStatus: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/status`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Stop a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name StopDeployment
         * @summary Stop Deployment
         * @request POST:/deployments/{deployment_id}/stop
         * @secure
         */
        stopDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/stop`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    errors = {
        /**
         * @description List application errors.
         *
         * @tags monitor
         * @name ListErrors
         * @summary List Errors
         * @request GET:/errors
         * @secure
         */
        listErrors: (params = {}) => this.request({
            path: `/errors`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    exampleStreams = {
        /**
         * @description List example streams. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name ListExampleStreams
         * @summary List Example Streams
         * @request GET:/example-streams
         * @secure
         */
        listExampleStreams: (query, params = {}) => this.request({
            path: `/example-streams`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name CreateExampleStream
         * @summary Create Example Stream
         * @request POST:/example-streams
         * @secure
         */
        createExampleStream: (data, params = {}) => this.request({
            path: `/example-streams`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Disable an example stream. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name DeleteExampleStream
         * @summary Delete Example Stream
         * @request DELETE:/example-streams/{example_stream_id}
         * @secure
         */
        deleteExampleStream: (exampleStreamId, query, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}`,
            method: "DELETE",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get example stream. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name GetExampleStream
         * @summary Get Example Stream
         * @request GET:/example-streams/{example_stream_id}
         * @secure
         */
        getExampleStream: (exampleStreamId, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update example stream. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name UpdateExampleStream
         * @summary Update Example Stream
         * @request PATCH:/example-streams/{example_stream_id}
         * @secure
         */
        updateExampleStream: (exampleStreamId, data, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name GetCameraConfigData
         * @summary Get Camera Config Data
         * @request GET:/example-streams/{example_stream_id}/cameras/{camera_id}/config
         * @secure
         */
        getCameraConfigData: (exampleStreamId, cameraId, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/cameras/${cameraId}/config`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description Update example stream config status. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name UpdateExampleStreamConfigStatus
         * @summary Update Example Stream Config Status
         * @request PUT:/example-streams/{example_stream_id}/config-status
         * @secure
         */
        updateExampleStreamConfigStatus: (exampleStreamId, data, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/config-status`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update example stream status. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name UpdateExampleStreamStatus
         * @summary Update Example Stream Status
         * @request PUT:/example-streams/{example_stream_id}/status
         * @secure
         */
        updateExampleStreamStatus: (exampleStreamId, query, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/status`,
            method: "PUT",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name GetValidationLogs
         * @summary Get Validation Logs
         * @request GET:/example-streams/{example_stream_id}/validation-logs
         * @secure
         */
        getValidationLogs: (exampleStreamId, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/validation-logs`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name AddValidationLogs
         * @summary Add Validation Logs
         * @request PUT:/example-streams/{example_stream_id}/validation-logs
         * @secure
         */
        addValidationLogs: (exampleStreamId, data, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/validation-logs`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
    };
    jobs = {
        /**
         * @description List all jobs. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobs
         * @summary List Jobs
         * @request GET:/jobs
         * @secure
         */
        listJobs: (query, params = {}) => this.request({
            path: `/jobs`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Start a job. All parameters (parameters, models, datasets) are linked with the `job_id`. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags jobs
         * @name StartJob
         * @summary Start Job
         * @request POST:/jobs
         * @secure
         */
        startJob: (data, params = {}) => this.request({
            path: `/jobs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List job fields. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobFields
         * @summary List Job Fields
         * @request GET:/jobs/fields
         * @secure
         */
        listJobFields: (params = {}) => this.request({
            path: `/jobs/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Register an external job. Alternative for start_job, but without actually starting the job. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags jobs
         * @name RegisterExternalJob
         * @summary Register External Job
         * @request POST:/jobs/register
         * @secure
         */
        registerExternalJob: (data, params = {}) => this.request({
            path: `/jobs/register`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a job. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags jobs
         * @name DeleteJob
         * @summary Delete Job
         * @request DELETE:/jobs/{job_id}
         * @secure
         */
        deleteJob: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a job. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name GetJob
         * @summary Get Job
         * @request GET:/jobs/{job_id}
         * @secure
         */
        getJob: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get job api endpoints info. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
         *
         * @tags jobs
         * @name GetJobApiEndpoints
         * @summary Get Job Api Endpoints
         * @request GET:/jobs/{job_id}/api-endpoints
         * @secure
         */
        getJobApiEndpoints: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/api-endpoints`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get artifacts of a job. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
         *
         * @tags jobs
         * @name GetJobArtifacts
         * @summary Get Job Artifacts
         * @request GET:/jobs/{job_id}/artifacts
         * @secure
         */
        getJobArtifacts: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/artifacts`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name GetJobCreator
         * @summary Get Job Creator
         * @request GET:/jobs/{job_id}/creator
         * @secure
         */
        getJobCreator: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/creator`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get job dependencies. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
         *
         * @tags jobs
         * @name GetJobDependencies
         * @summary Get Job Dependencies
         * @request GET:/jobs/{job_id}/dependencies
         * @secure
         */
        getJobDependencies: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/dependencies`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get logs of a job. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name GetJobLogs
         * @summary Get Job Logs
         * @request GET:/jobs/{job_id}/logs
         * @secure
         */
        getJobLogs: (jobId, query, params = {}) => this.request({
            path: `/jobs/${jobId}/logs`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        /**
         * @description Save logs to job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name SaveJobLogs
         * @summary Save Job Logs
         * @request PUT:/jobs/{job_id}/logs
         * @secure
         */
        saveJobLogs: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/logs`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Get latest status messages of a job. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobMessages
         * @summary List Job Messages
         * @request GET:/jobs/{job_id}/messages
         * @secure
         */
        listJobMessages: (jobId, query, params = {}) => this.request({
            path: `/jobs/${jobId}/messages`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Log a status message for a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name LogJobMessage
         * @summary Log Job Message
         * @request POST:/jobs/{job_id}/messages
         * @secure
         */
        logJobMessage: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/messages`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description List job message fields. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobMessageFields
         * @summary List Job Message Fields
         * @request GET:/jobs/{job_id}/messages/fields
         * @secure
         */
        listJobMessageFields: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/messages/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the metadata of a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name UpdateJobMetadata
         * @summary Update Job Metadata
         * @request PUT:/jobs/{job_id}/metadata
         * @secure
         */
        updateJobMetadata: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update status to job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name UpdateJobStatus
         * @summary Update Job Status
         * @request POST:/jobs/{job_id}/status
         * @secure
         */
        updateJobStatus: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/status`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Stop a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name StopJob
         * @summary Stop Job
         * @request POST:/jobs/{job_id}/stop
         * @secure
         */
        stopJob: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/stop`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    livez = {
        /**
         * @description Get application heartbeat.
         *
         * @tags monitor
         * @name GetHeartbeat
         * @summary Get Heartbeat
         * @request GET:/livez
         * @secure
         */
        getHeartbeat: (params = {}) => this.request({
            path: `/livez`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    logs = {
        /**
         * @description Prepare server logs.
         *
         * @tags monitor
         * @name PrepareLogs
         * @summary Prepare Logs
         * @request POST:/logs
         * @secure
         */
        prepareLogs: (query, params = {}) => this.request({
            path: `/logs`,
            method: "POST",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Download server logs.
         *
         * @tags monitor
         * @name DownloadLogs
         * @summary Download Logs
         * @request GET:/logs/{zip_filename}
         * @secure
         */
        downloadLogs: (zipFilename, params = {}) => this.request({
            path: `/logs/${zipFilename}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    platformConnection = {
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name DeletePlatformConnection
         * @summary Delete Platform Connection
         * @request DELETE:/platform-connection
         * @secure
         */
        deletePlatformConnection: (params = {}) => this.request({
            path: `/platform-connection`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetPlatformConnection
         * @summary Get Platform Connection
         * @request GET:/platform-connection
         * @secure
         */
        getPlatformConnection: (params = {}) => this.request({
            path: `/platform-connection`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name CreatePlatformConnection
         * @summary Create Platform Connection
         * @request POST:/platform-connection
         * @secure
         */
        createPlatformConnection: (data, params = {}) => this.request({
            path: `/platform-connection`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ListAlgorithmsFromConnection
         * @summary List Algorithms From Connection
         * @request GET:/platform-connection/algorithms
         * @secure
         */
        listAlgorithmsFromConnection: (query, params = {}) => this.request({
            path: `/platform-connection/algorithms`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ListDeploymentsFromConnection
         * @summary List Deployments From Connection
         * @request GET:/platform-connection/deployments
         * @secure
         */
        listDeploymentsFromConnection: (query, params = {}) => this.request({
            path: `/platform-connection/deployments`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetDeploymentDependenciesFromConnection
         * @summary Get Deployment Dependencies From Connection
         * @request GET:/platform-connection/deployments/{deployment_id}/dependencies
         * @secure
         */
        getDeploymentDependenciesFromConnection: (deploymentId, params = {}) => this.request({
            path: `/platform-connection/deployments/${deploymentId}/dependencies`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List all projects from the latest hub connection that are compatible with the current project. Compatible projects are projects with the same algorithm type. If no connection id is provided, it defaults to the latest one that was set up. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ListProjectsFromConnection
         * @summary List Projects From Connection
         * @request GET:/platform-connection/projects
         * @secure
         */
        listProjectsFromConnection: (query, params = {}) => this.request({
            path: `/platform-connection/projects`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD EDGE * DATA_UPLOAD MODEL_CREATION * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetParametersResourceDataFromConnection
         * @summary Get Parameters Resource Data From Connection
         * @request GET:/platform-connection/resources/parameters/{resource_id}/data
         * @secure
         */
        getParametersResourceDataFromConnection: (resourceId, params = {}) => this.request({
            path: `/platform-connection/resources/parameters/${resourceId}/data`,
            method: "GET",
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ValidatePlatformConnection
         * @summary Validate Platform Connection
         * @request GET:/platform-connection/validate
         * @secure
         */
        validatePlatformConnection: (params = {}) => this.request({
            path: `/platform-connection/validate`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ValidateCredentials
         * @summary Validate Credentials
         * @request POST:/platform-connection/validate
         * @secure
         */
        validateCredentials: (data, params = {}) => this.request({
            path: `/platform-connection/validate`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    projects = {
        /**
         * @description List all projects. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name ListProjects
         * @summary List Projects
         * @request GET:/projects
         * @secure
         */
        listProjects: (query, params = {}) => this.request({
            path: `/projects`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a project. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name CreateProject
         * @summary Create Project
         * @request POST:/projects
         * @secure
         */
        createProject: (data, params = {}) => this.request({
            path: `/projects`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List project fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name ListProjectFields
         * @summary List Project Fields
         * @request GET:/projects/fields
         * @secure
         */
        listProjectFields: (params = {}) => this.request({
            path: `/projects/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List all project metadata. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name ListProjectMetadata
         * @summary List Project Metadata
         * @request GET:/projects/metadata
         * @secure
         */
        listProjectMetadata: (params = {}) => this.request({
            path: `/projects/metadata`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a project by its name. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetProjectByName
         * @summary Get Project By Name
         * @request GET:/projects/name/{project_name}
         * @secure
         */
        getProjectByName: (projectName, params = {}) => this.request({
            path: `/projects/name/${projectName}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Check project name's existence. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name IsProjectNameAvailable
         * @summary Is Project Name Available
         * @request GET:/projects/name/{project_name}/availability
         * @secure
         */
        isProjectNameAvailable: (projectName, params = {}) => this.request({
            path: `/projects/name/${projectName}/availability`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a project. **Accepted permissions:** * INFERENCE MODEL_CREATION PROJECT_CREATION * MODEL_CREATION PROJECT_CREATION SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name DeleteProject
         * @summary Delete Project
         * @request DELETE:/projects/{project_id}
         * @secure
         */
        deleteProject: (projectId, params = {}) => this.request({
            path: `/projects/${projectId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a project. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetProject
         * @summary Get Project
         * @request GET:/projects/{project_id}
         * @secure
         */
        getProject: (projectId, params = {}) => this.request({
            path: `/projects/${projectId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a project. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name UpdateProject
         * @summary Update Project
         * @request PATCH:/projects/{project_id}
         * @secure
         */
        updateProject: (projectId, data, params = {}) => this.request({
            path: `/projects/${projectId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a default algorithm in project. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name UpdateProjectDefaultAlgorithm
         * @summary Update Project Default Algorithm
         * @request PATCH:/projects/{project_id}/algorithm
         * @secure
         */
        updateProjectDefaultAlgorithm: (projectId, data, params = {}) => this.request({
            path: `/projects/${projectId}/algorithm`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get default project example definitions. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetDefaultProjectExampleDefinitions
         * @summary Get Default Project Example Definitions
         * @request GET:/projects/{project_id}/example-definitions
         * @secure
         */
        getDefaultProjectExampleDefinitions: (projectId, params = {}) => this.request({
            path: `/projects/${projectId}/example-definitions`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get project thumbnail. Supports authorization via ?token. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetProjectThumbnail
         * @summary Get Project Thumbnail
         * @request GET:/projects/{project_id}/thumbnail
         * @secure
         */
        getProjectThumbnail: (projectId, query, params = {}) => this.request({
            path: `/projects/${projectId}/thumbnail`,
            method: "GET",
            query: query,
            secure: true,
            format: "blob",
            ...params,
        }),
    };
    prometheus = {
        /**
         * No description
         *
         * @tags monitor
         * @name GetPrometheusMetrics
         * @summary Get Prometheus Metrics
         * @request GET:/prometheus
         * @secure
         */
        getPrometheusMetrics: (params = {}) => this.request({
            path: `/prometheus`,
            method: "GET",
            secure: true,
            ...params,
        }),
    };
    resources = {
        /**
         * @description List resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListResources
         * @summary List Resources
         * @request GET:/resources/
         * @secure
         */
        listResources: (query, params = {}) => this.request({
            path: `/resources/`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List blob resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListBlobResources
         * @summary List Blob Resources
         * @request GET:/resources/blobs
         * @secure
         */
        listBlobResources: (query, params = {}) => this.request({
            path: `/resources/blobs`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create generic blob resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateBlobResource
         * @summary Create Blob Resource
         * @request POST:/resources/blobs
         * @secure
         */
        createBlobResource: (data, params = {}) => this.request({
            path: `/resources/blobs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get blob resource info. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetBlobResourceInfo
         * @summary Get Blob Resource Info
         * @request GET:/resources/blobs/{resource_id}
         * @secure
         */
        getBlobResourceInfo: (resourceId, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Override blob resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name OverrideBlobResourceMetadata
         * @summary Override Blob Resource Metadata
         * @request PUT:/resources/blobs/{resource_id}
         * @secure
         */
        overrideBlobResourceMetadata: (resourceId, data, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get blob resource data. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetBlobResourceData
         * @summary Get Blob Resource Data
         * @request GET:/resources/blobs/{resource_id}/data
         * @secure
         */
        getBlobResourceData: (resourceId, query, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}/data`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description Put blob resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name PutBlobResourceData
         * @summary Put Blob Resource Data
         * @request PUT:/resources/blobs/{resource_id}/data
         * @secure
         */
        putBlobResourceData: (resourceId, data, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}/data`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List resource fields. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListResourceFields
         * @summary List Resource Fields
         * @request GET:/resources/fields
         * @secure
         */
        listResourceFields: (params = {}) => this.request({
            path: `/resources/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List model resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListModelResources
         * @summary List Model Resources
         * @request GET:/resources/models
         * @secure
         */
        listModelResources: (query, params = {}) => this.request({
            path: `/resources/models`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create model resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateModelResource
         * @summary Create Model Resource
         * @request POST:/resources/models
         * @secure
         */
        createModelResource: (data, params = {}) => this.request({
            path: `/resources/models`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get model resource info. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetModelResourceInfo
         * @summary Get Model Resource Info
         * @request GET:/resources/models/{resource_id}
         * @secure
         */
        getModelResourceInfo: (resourceId, params = {}) => this.request({
            path: `/resources/models/${resourceId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Override models resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name OverrideModelResourceMetadata
         * @summary Override Model Resource Metadata
         * @request PUT:/resources/models/{resource_id}
         * @secure
         */
        overrideModelResourceMetadata: (resourceId, data, params = {}) => this.request({
            path: `/resources/models/${resourceId}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get model resource data. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetModelResourceData
         * @summary Get Model Resource Data
         * @request GET:/resources/models/{resource_id}/data
         * @secure
         */
        getModelResourceData: (resourceId, query, params = {}) => this.request({
            path: `/resources/models/${resourceId}/data`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description Put model resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name PutModelResourceData
         * @summary Put Model Resource Data
         * @request PUT:/resources/models/{resource_id}/data
         * @secure
         */
        putModelResourceData: (resourceId, data, params = {}) => this.request({
            path: `/resources/models/${resourceId}/data`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List parameters resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListParametersResources
         * @summary List Parameters Resources
         * @request GET:/resources/parameters
         * @secure
         */
        listParametersResources: (query, params = {}) => this.request({
            path: `/resources/parameters`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a parameters resource. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateParametersResource
         * @summary Create Parameters Resource
         * @request POST:/resources/parameters
         * @secure
         */
        createParametersResource: (data, params = {}) => this.request({
            path: `/resources/parameters`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Create parameters resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateParametersResourceWithUploadUrl
         * @summary Create Parameters Resource With Upload Url
         * @request POST:/resources/parameters/metadata
         * @secure
         */
        createParametersResourceWithUploadUrl: (data, params = {}) => this.request({
            path: `/resources/parameters/metadata`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get parameters resource info. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetParametersResourceInfo
         * @summary Get Parameters Resource Info
         * @request GET:/resources/parameters/{resource_id}
         * @secure
         */
        getParametersResourceInfo: (resourceId, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Override parameters resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name OverrideParametersResourceMetadata
         * @summary Override Parameters Resource Metadata
         * @request PUT:/resources/parameters/{resource_id}
         * @secure
         */
        overrideParametersResourceMetadata: (resourceId, data, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get parameters resource data. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetParametersResourceData
         * @summary Get Parameters Resource Data
         * @request GET:/resources/parameters/{resource_id}/data
         * @secure
         */
        getParametersResourceData: (resourceId, query, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}/data`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description Put parameters resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name PutParametersResourceData
         * @summary Put Parameters Resource Data
         * @request PUT:/resources/parameters/{resource_id}/data
         * @secure
         */
        putParametersResourceData: (resourceId, data, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}/data`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get parameters resource definition. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetParametersResourceDefinition
         * @summary Get Parameters Resource Definition
         * @request GET:/resources/parameters/{resource_id}/definition
         * @secure
         */
        getParametersResourceDefinition: (resourceId, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}/definition`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete resource. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name DeleteResource
         * @summary Delete Resource
         * @request DELETE:/resources/{resource_id}
         * @secure
         */
        deleteResource: (resourceId, params = {}) => this.request({
            path: `/resources/${resourceId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    schemas = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags schemas
         * @name GetDatapoolDefinition
         * @summary Get Datapool Definition
         * @request GET:/schemas/datapool/{definition_id}
         * @secure
         */
        getDatapoolDefinition: (definitionId, params = {}) => this.request({
            path: `/schemas/datapool/${definitionId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    sse = {
        /**
         * No description
         *
         * @tags sse
         * @name GetEvents
         * @summary Get Events
         * @request GET:/sse
         * @secure
         */
        getEvents: (query, params = {}) => this.request({
            path: `/sse`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
    };
    storageCapacity = {
        /**
         * No description
         *
         * @tags storage_capacity
         * @name GetStorageCapacities
         * @summary Get Storage Capacities
         * @request GET:/storage-capacity
         * @secure
         */
        getStorageCapacities: (params = {}) => this.request({
            path: `/storage-capacity`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    termsAndConditions = {
        /**
         * @description Returns the terms and conditions as a PDF. If the terms and conditions have not been overridden, the default terms and conditions should be shown.
         *
         * @tags monitor
         * @name GetTermsAndConditions
         * @summary Get Terms And Conditions
         * @request GET:/terms-and-conditions/pdf
         * @secure
         */
        getTermsAndConditions: (query, params = {}) => this.request({
            path: `/terms-and-conditions/pdf`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
    };
    version = {
        /**
         * @description Get application version.
         *
         * @tags monitor
         * @name GetVersion
         * @summary Get Version
         * @request GET:/version
         * @secure
         */
        getVersion: (params = {}) => this.request({
            path: `/version`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    viewTemplates = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name ListExampleStreamViewTemplates
         * @summary List Example Stream View Templates
         * @request GET:/view-templates
         * @secure
         */
        listExampleStreamViewTemplates: (params = {}) => this.request({
            path: `/view-templates`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    workflows = {
        /**
         * @description List all workflows. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name ListWorkflows
         * @summary List Workflows
         * @request GET:/workflows
         * @secure
         */
        listWorkflows: (query, params = {}) => this.request({
            path: `/workflows`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Start a workflow. All parameters (parameters, models, datasets) are linked with the `workflow_id`. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags workflows
         * @name StartWorkflow
         * @summary Start Workflow
         * @request POST:/workflows
         * @secure
         */
        startWorkflow: (data, params = {}) => this.request({
            path: `/workflows`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List workflow fields. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name ListWorkflowFields
         * @summary List Workflow Fields
         * @request GET:/workflows/fields
         * @secure
         */
        listWorkflowFields: (params = {}) => this.request({
            path: `/workflows/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Register an external workflow. Alternative for start_workflow, but without actually starting the workflow. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags workflows
         * @name RegisterExternalWorkflow
         * @summary Register External Workflow
         * @request POST:/workflows/register
         * @secure
         */
        registerExternalWorkflow: (data, params = {}) => this.request({
            path: `/workflows/register`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a workflow. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags workflows
         * @name DeleteWorkflow
         * @summary Delete Workflow
         * @request DELETE:/workflows/{workflow_id}
         * @secure
         */
        deleteWorkflow: (workflowId, params = {}) => this.request({
            path: `/workflows/${workflowId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a workflow. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name GetWorkflow
         * @summary Get Workflow
         * @request GET:/workflows/{workflow_id}
         * @secure
         */
        getWorkflow: (workflowId, params = {}) => this.request({
            path: `/workflows/${workflowId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the metadata of a workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name UpdateWorkflowMetadata
         * @summary Update Workflow Metadata
         * @request PUT:/workflows/{workflow_id}/metadata
         * @secure
         */
        updateWorkflowMetadata: (workflowId, data, params = {}) => this.request({
            path: `/workflows/${workflowId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update status of workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name UpdateWorkflowStatus
         * @summary Update Workflow Status
         * @request POST:/workflows/{workflow_id}/status
         * @secure
         */
        updateWorkflowStatus: (workflowId, data, params = {}) => this.request({
            path: `/workflows/${workflowId}/status`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Stop a workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name StopWorkflow
         * @summary Stop Workflow
         * @request POST:/workflows/{workflow_id}/stop
         * @secure
         */
        stopWorkflow: (workflowId, params = {}) => this.request({
            path: `/workflows/${workflowId}/stop`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
    };
}
//# sourceMappingURL=data:application/json;base64,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